import { getNestedProperty } from '@opallabs/lambda'

export const navigateToMoment = ({
  momentId,
  navigateTo,
  storyId,
  primaryBrand,
}) => {
  const momentState = getNestedProperty(window, 'OpalMoments', 'State')
  const brand = momentState && momentState.current_brand
  const slug = brand.get('slug')

  if (storyId) {
    return primaryBrand
      ? window.open(
          `${window.location.origin}/moments/${primaryBrand.slug}/stories/${storyId}/moments/${momentId}#close_window`,
          '_blank'
        )
      : navigateTo({
          route: `moments/${slug}/stories/${storyId}/moments/${momentId}`,
        })
  }
  return primaryBrand
    ? window.open(
        `${window.location.origin}/moments/${primaryBrand.slug}/${momentId}#close_window`,
        '_blank'
      )
    : navigateTo({ route: `moments/${slug}/${momentId}` })
}

export const navigateToContent = ({
  contentId,
  momentId,
  navigateTo,
  storyId,
  path = '',
  primaryBrand,
}) => {
  const momentState = getNestedProperty(window, 'OpalMoments', 'State')
  const brand = momentState && momentState.current_brand
  const slug = brand.get('slug')

  momentState.post_shroud_view_mode = 'single'
  if (storyId) {
    return primaryBrand
      ? window.open(
          `${window.location.origin}/moments/${primaryBrand.slug}/stories/` +
            `${storyId}/moments/${momentId}/posts/${contentId}${path}#close_window`,
          '_blank'
        )
      : navigateTo({
          route: `moments/${slug}/stories/${storyId}/moments/${momentId}/posts/${contentId}${path}`,
        })
  }
  return primaryBrand
    ? window.open(
        `${primaryBrand.slug}/${momentId}/posts/${contentId}${path}#close_window`,
        '_blank'
      )
    : navigateTo({
        route: `moments/${slug}/${momentId}/posts/${contentId}${path}`,
      })
}
